import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getSettingTopShopRetailerExperienceEnabledByRegion } from "@faire/retailer-visitor-shared/settings/getSettingTopShopRetailerExperienceEnabledByRegion";
export var useTopShopVisibility = function() {
    var isBrandTopShop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var isTopShopEnabled = getSettingTopShopRetailerExperienceEnabledByRegion();
    var isBrandPreview = useIsBrandPreview();
    return getTopShopVisibility(isTopShopEnabled, isBrandTopShop, isBrandPreview);
};
export var getTopShopVisibility = function(isTopShopEnabled, isBrandTopShop, isBrandPreview) {
    var isTopShopContentVisible = isTopShopEnabled || isBrandPreview;
    var isTopShopContentVisibleForBrand = isTopShopContentVisible && isBrandTopShop;
    return {
        isTopShopEnabled: isTopShopEnabled,
        isTopShopContentVisible: isTopShopContentVisible,
        isTopShopContentVisibleForBrand: isTopShopContentVisibleForBrand
    };
};
